"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUuid = exports.stringIsUuid = exports.stringIsISODate = exports.stringIsFloat = exports.stringIsInt = exports.compatibleCases = exports.isKebabLower = exports.isKebabUpper = exports.isSnakeLower = exports.isSnakeUpper = exports.isCamelLower = exports.isCamelUpper = void 0;
exports.dateFromIsoFilename = dateFromIsoFilename;
exports.dateToIsoFilename = dateToIsoFilename;
exports.indent = indent;
exports.joinLast = joinLast;
exports.joinLimit = joinLimit;
exports.maxLen = maxLen;
exports.pathJoin = pathJoin;
exports.pathParent = pathParent;
exports.plural = plural;
exports.pluralize = pluralize;
exports.pluralizeL = pluralizeL;
exports.pluralizeR = pluralizeR;
exports.removeSurroundingParentheses = removeSurroundingParentheses;
exports.singular = singular;
exports.cleanText = cleanText;
exports.slugify = slugify;
exports.slugifyGitHub = slugifyGitHub;
exports.splitWords = splitWords;
exports.stripIndent = stripIndent;
const array_1 = require("./array");
const validation_1 = require("./validation");
// functions sorted alphabetically
function dateFromIsoFilename(d) {
    const [, year, month, day, hour, min, sec, milli] = d.match(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d)-(\d\d)-(\d\d)-(\d\d\d)Z/) || [];
    if (year) {
        return new Date(`${year}-${month}-${day}T${hour}:${min}:${sec}.${milli}Z`);
    }
    else {
        throw new Error(`Invalid filename iso date: ${d}`);
    }
}
function dateToIsoFilename(d) {
    return d.toISOString().replaceAll(':', '-').replaceAll('.', '-');
}
function indent(value, size = 2, char = ' ') {
    const prefix = char.repeat(size);
    return value.split('\n').map(l => prefix + l).join('\n');
}
const isCamelUpper = (value) => !!value.match(/^([A-Z][a-z0-9]*)+$/);
exports.isCamelUpper = isCamelUpper;
const isCamelLower = (value) => !!value.match(/^([a-z][a-z0-9]*)([A-Z][a-z0-9]*)*$/);
exports.isCamelLower = isCamelLower;
const isSnakeUpper = (value) => !!value.match(/^([A-Z][A-Z0-9]*)(_[A-Z0-9]*)*$/);
exports.isSnakeUpper = isSnakeUpper;
const isSnakeLower = (value) => !!value.match(/^([a-z][a-z0-9]*)(_[a-z0-9]*)*$/);
exports.isSnakeLower = isSnakeLower;
const isKebabUpper = (value) => !!value.match(/^([A-Z][A-Z0-9]*)(-[A-Z0-9]*)*$/);
exports.isKebabUpper = isKebabUpper;
const isKebabLower = (value) => !!value.match(/^([a-z][a-z0-9]*)(-[a-z0-9]*)*$/);
exports.isKebabLower = isKebabLower;
const compatibleCases = (value) => [
    (0, exports.isCamelUpper)(value) ? 'camel-upper' : undefined,
    (0, exports.isCamelLower)(value) ? 'camel-lower' : undefined,
    (0, exports.isSnakeUpper)(value) ? 'snake-upper' : undefined,
    (0, exports.isSnakeLower)(value) ? 'snake-lower' : undefined,
    (0, exports.isKebabUpper)(value) ? 'kebab-upper' : undefined,
    (0, exports.isKebabLower)(value) ? 'kebab-lower' : undefined,
].filter(validation_1.isNotUndefined);
exports.compatibleCases = compatibleCases;
function joinLast(values, sep = ', ', last = ' and ') {
    if (values.length === 0) {
        return '';
    }
    else if (values.length === 1) {
        return values[0];
    }
    else {
        return values.slice(0, -1).join(sep) + last + values[values.length - 1];
    }
}
function joinLimit(values, sep = ', ', limit = 5) {
    if (values.length > limit) {
        return values.slice(0, limit).join(sep) + ' ...';
    }
    else {
        return values.join(sep);
    }
}
function maxLen(value, max) {
    if (value.length > max) {
        return value.slice(0, max - 3) + '...';
    }
    else {
        return value;
    }
}
function pathJoin(...paths) {
    const res = paths
        .flatMap(path => path.split('/'))
        .filter(part => part !== '' && part !== '.') // remove useless parts
        .filter((part, i, parts) => (part !== '..' && parts[i + 1] !== '..') || (part === '..' && (parts[i - 1] === '..' || parts[i - 1] === undefined))) // squash parents
        .filter((part, i, parts) => (part !== '..' && parts[i + 1] !== '..') || (part === '..' && (parts[i - 1] === '..' || parts[i - 1] === undefined))) // squash parents again (if 2 levels)
        .join('/');
    return res.startsWith('.') || res.startsWith('~') ? res : './' + res; // add explicit relative link
}
function pathParent(path) {
    return pathJoin(...path.split('/').filter(p => !!p).slice(0, -1));
}
function plural(word) {
    if (word.endsWith('y') && !(word.endsWith('ay') || word.endsWith('ey') || word.endsWith('oy') || word.endsWith('uy'))) {
        return word.slice(0, -1) + 'ies';
    }
    else if (word.endsWith('s') || word.endsWith('x') || word.endsWith('z') || word.endsWith('sh') || word.endsWith('ch')) {
        return word + 'es';
    }
    else {
        return word + 's';
    }
}
function pluralize(count, word) {
    if (count === 1) {
        return `1 ${word}`;
    }
    else {
        return `${count} ${plural(word)}`;
    }
}
function pluralizeL(items, word) {
    return pluralize(items.length, word);
}
function pluralizeR(record, word) {
    return pluralize(Object.keys(record).length, word);
}
function removeSurroundingParentheses(value) {
    if (value.startsWith('(') && value.endsWith(')')) {
        return removeSurroundingParentheses(value.slice(1, -1));
    }
    else {
        return value;
    }
}
function singular(word) {
    if (word.endsWith('ies')) {
        return word.slice(0, -3) + 'y';
    }
    else if (word.endsWith('ses') || word.endsWith('xes') || word.endsWith('zes') || word.endsWith('hes')) {
        return word.slice(0, -2);
    }
    else if (word.endsWith('s')) {
        return word.slice(0, -1);
    }
    else {
        return word;
    }
}
function cleanText(text) {
    return text
        .trim()
        .toLowerCase()
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, ''); // remove all the accents
}
function slugify(text) {
    return cleanText(text)
        .replace(/[^a-z0-9]/g, '-') // replace other chars with '-'
        .replace(/-+/g, '-') // only keep a single '-'
        .replace(/^-+/, '') // remove leading '-'
        .replace(/-+$/, ''); // remove training '-'
}
function slugifyGitHub(text) {
    return cleanText(text)
        .replace(/[^a-z0-9 _-]/g, '') // remove non-alphanumeric characters
        .replace(/\s/g, '-'); // replace spaces with hyphens
}
function splitWords(text) {
    const { word, words } = Array.from(text).reduce(({ word, words }, cur) => {
        const code = cur.charCodeAt(0);
        if (isLowerChar(code) || isNumber(code)) {
            return { word: word + cur, words: words };
        }
        else if (isUpperChar(code)) {
            const len = word.length;
            if (len === 0 || isUpperChar(word.charCodeAt(len - 1))) {
                return { word: word + cur, words: words };
            }
            else {
                return { word: cur, words: word ? words.concat([word]) : words };
            }
        }
        else {
            return { word: '', words: word ? words.concat([word]) : words };
        }
    }, { word: '', words: [] });
    return words.concat([word]).filter(w => !!w).map(w => w.toLowerCase());
}
// avoid regex for better perf
const isLowerChar = (code) => 97 <= code && code <= 122;
const isUpperChar = (code) => 65 <= code && code <= 90;
const isNumber = (code) => 48 <= code && code <= 57;
const stringIsInt = (value) => value.match(/^\d+$/g) !== null;
exports.stringIsInt = stringIsInt;
const stringIsFloat = (value) => value.match(/^\d+(\.\d+)?$/g) !== null;
exports.stringIsFloat = stringIsFloat;
const stringIsISODate = (value) => value.match(/^\d\d\d\d-[01]\d-[0123]\dT[012]\d:[012345]\d:[012345]\d\.\d\d\dZ$/g) !== null;
exports.stringIsISODate = stringIsISODate;
const stringIsUuid = (value) => value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/gi) !== null;
exports.stringIsUuid = stringIsUuid;
const parseUuid = (value) => {
    const [, version, variant] = /^[0-9a-f]{8}-[0-9a-f]{4}-([0-9a-f])[0-9a-f]{3}-([0-9a-f])[0-9a-f]{3}-[0-9a-f]{12}$/gi.exec(value) || [];
    return { version, variant };
};
exports.parseUuid = parseUuid;
function stripIndent(value) {
    const lines = value.split('\n');
    const lengths = lines.map(l => l.trim().length);
    const firstIndex = lengths.findIndex(l => l > 0);
    const lastIndex = (0, array_1.findLastIndex)(lengths, l => l > 0);
    const content = lines.slice(firstIndex, lastIndex + 1);
    const minIndent = content.reduce((acc, line) => {
        const len = line.trim().length > 0 && line.match(/^(\s*).*$/)?.[1]?.length || 0;
        return acc === undefined || (0 < len && len < acc) ? len : acc;
    }, undefined);
    return content.map(l => l.slice(minIndent)).join('\n');
}
//# sourceMappingURL=string.js.map